import { BsSuitcaseLg } from 'react-icons/bs';
import { Fragment, JSX } from 'react/jsx-runtime';
import { IconContext } from 'react-icons';
import { IoIosStarOutline } from 'react-icons/io';
import { LiaBirthdayCakeSolid } from 'react-icons/lia';
import { LuTreePalm } from 'react-icons/lu';
import { MdOutlineWorkOff } from 'react-icons/md';
import { TbAward, TbLicense } from 'react-icons/tb';

import { TipoPeriodoDescanso } from './enums/tipo-periodo-descanso.enum';

/**
 * Retorna o ícone do tipo de período selecionado.
 * @param tipo TipoPeriodo
 * @returns JSX.Element
 */
export function IconeDoTipoPeriodo(tipo: TipoPeriodoDescanso) {
  let elemento: JSX.Element = <Fragment></Fragment>;
  let cor = 'black';

  switch (tipo) {
    case TipoPeriodoDescanso.Ferias:
      elemento = <LuTreePalm title="Férias" />;
      cor = 'green';
      break;
    case TipoPeriodoDescanso.FolgaNatalicia:
      elemento = <LiaBirthdayCakeSolid title="Folga Natalícia" />;
      cor = 'blue';
      break;
    case TipoPeriodoDescanso.AbonoTrabalhado:
      elemento = <MdOutlineWorkOff title="Abono Trabalhado" />;
      cor = 'orange';
      break;
    case TipoPeriodoDescanso.AbonoEspecial:
      elemento = <IoIosStarOutline title="Abono Especial" />;
      cor = 'gold';
      break;
    case TipoPeriodoDescanso.LicencaPremio:
      elemento = <TbAward title="Licença Prêmio" />;
      cor = 'purple';
      break;
    case TipoPeriodoDescanso.LicencaOutros:
      elemento = <TbLicense title="Licença Outros" />;
      cor = 'brown';
      break;
    // case TipoPeriodoDescanso.Afastamento:
    //   elemento = <RiNotificationOffLine title='Afastamento' />; cor = 'red';
    //   break;
    default:
      elemento = <BsSuitcaseLg title="Trabalhando" />;
      cor = 'black';
      break;
  }

  return (
    <IconContext.Provider
      value={{ color: cor }}
      children={elemento}
    ></IconContext.Provider>
  );
}
